import Velocity from 'velocity-animate';

export function enterAnimation(el, done) {
  Velocity(el, 'slideDown', {
    duration: 250,
    complete() {
      done();
    }
  });
}

export function leaveAnimation(el, done) {
  Velocity(el, 'slideUp', {
    duration: 250,
    complete() {
      done();
    }
  });
}
